export default function SiteIntro() {
  const points = [
    {
      icon: "ri-stack-line",
      title: "多维度内容聚合",
      text: "覆盖社会、娱乐、财经、网络等多个方向，兼顾快速浏览与深度阅读。",
    },
    {
      icon: "ri-shield-check-line",
      title: "来源与时间清晰",
      text: "每条信息均标注来源与发布时间，帮助您判断内容的时效与参考价值。",
    },
    {
      icon: "ri-links-line",
      title: "分类与推荐联动",
      text: "通过分类入口与相关推荐，顺畅地从一条信息扩展到更多同类话题。",
    },
  ];

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              关于黑料官网
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              黑料官网是一个专注于黑料信息汇总与解析的综合信息站。我们围绕“信息发现、快速筛选、深入了解、扩展阅读”设计站点结构，
              让用户能够在同一处便捷地浏览最新动态、追踪社会热点，并形成自己的判断。
            </p>
            <p className="mt-4 text-xs leading-6 text-foreground-400">
              提示：本站为演示项目，所有内容均为虚构示例，搜索与分享功能仅作效果展示。
            </p>
          </div>
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              {points.map((item, index) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-5 animate-fade-up"
                  style={{ animationDelay: `${index * 70}ms` }}
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}